import YouTubePlayer from "youtube-player";
import VimeoPlayer from "@vimeo/player";
import domReady from "@wordpress/dom-ready";

let players = [];

const initYoutubePlayers = (section) => {
	const thisYoutubePlayer = section.querySelector(".youtube-player");
	if (!thisYoutubePlayer) return false;

	const elemId = thisYoutubePlayer.getAttribute("id");
	const videoID = thisYoutubePlayer.getAttribute("data-video-id");
	players[elemId] = YouTubePlayer(elemId, {
		width: "1400",
		height: "788",
		videoId: videoID,
		playerVars: {
			mute: 1,
			controls: 0,
			loop: 1,
			playsinline: 1,
			rel: 0,
			showinfo: 0,
		},
	});
	// player.loadVideoById(videoID);
	// player.playVideo();
};

const initVimeoPlayers = (section) => {
	const thisVimeoPlayer = section.querySelector(".vimeo-player");
	if (!thisVimeoPlayer) return false;

	const elemId = thisVimeoPlayer.getAttribute("id");
	const videoID = thisVimeoPlayer.getAttribute("data-video-id");
	players[elemId] = new VimeoPlayer(elemId, {
		id: videoID,
		width: 1400,
		height: "auto",
		maxHeight: "100%",
		loop: true,
		controls: false,
	});
	players[elemId].setVolume(0);
	// player.play();
};

const playerHandlers = (section) => {
	const thisActionVideo = section.querySelector(".full-media__video-action");
	if (!thisActionVideo) return false;

	thisActionVideo.addEventListener("click", () => {
		const videoPlayer = section.querySelector(".video-player");
		if (!videoPlayer) return;

		const isVideoPlaying = section.classList.contains(
			"full-media--video-playing",
		);
		toggleVideoPlayState(videoPlayer, isVideoPlaying);
		toggleSectionPlayState(section, isVideoPlaying);
	});
};

const toggleVideoPlayState = (videoPlayer, isPlaying) => {
	if (videoPlayer.classList.contains("html5-player")) {
		isPlaying ? videoPlayer.pause() : videoPlayer.play();
	} else {
		const thisPlayer = players[videoPlayer.id];
		if (videoPlayer.classList.contains("youtube-player")) {
			isPlaying ? thisPlayer.pauseVideo() : thisPlayer.playVideo();
		} else {
			isPlaying ? thisPlayer.pause() : thisPlayer.play();
		}
	}
};

const toggleSectionPlayState = (section, isPlaying) => {
	isPlaying
		? section.classList.remove("full-media--video-playing")
		: section.classList.add("full-media--video-playing");
};

const initParallax = (section) => {
	const thisParallaxElem = section.querySelector(".full-media--with-parallax");
	if (!thisParallaxElem) return false;

	const el =
		thisParallaxElem.querySelector("img") ??
		thisParallaxElem.querySelector("video");

	if (!el) return false;

	window.customScrollbarInstance?.parallaxController?.createElement({
		el,
		props: {
			translateY: [-25, 10],
		},
	});
};

const fullMedia = () => {
	// console.log("FULL MEDIA");
	initYoutubePlayers();
	initVimeoPlayers();
	playerHandlers();
};

domReady(() => {
	// fullMedia();
	// initParallax();

	const allFullMediaSections = document.querySelectorAll(
		".wp-block-theme-blocks-full-media",
	);

	allFullMediaSections?.forEach((section) => {
		initParallax(section);
		initYoutubePlayers(section);
		initVimeoPlayers(section);
		playerHandlers(section);
	});
});

// window.addEventListener("change-page", fullMedia, true);
